import Characters from './Characters';
import React from "react";
import { useState, useEffect, useCallback } from "react";
import { practiceparagraphs } from "./Paragraphs";
import { BsArrowLeft } from "react-icons/bs";
import { Link } from 'react-router-dom';
import CenteredMessage from './CenteredMessage';

let ranIndex = Math.floor(Math.random() * practiceparagraphs.length);

const ErrorMode = () => {
  const [word, setWord] = useState('');
  const [para, setPara] = useState(practiceparagraphs[ranIndex]);
  const [showNotification, setShowNotification] = useState(false);
  const [chrIndex, setChrIndex] = useState(0);
  const [WPM, setWPM] = useState(0);
  const [errors, setErrors] = useState(0);
  const [accuracy, setAccuracy] = useState(100);

  const handleWordType = (e) => {
    if (errors >= 30) return; // Prevent further typing if errors reach 30

    const { value } = e.target;
    setWord(value);
    setChrIndex(value.length);

    const wordsTyped = (value.length - errors) / 5;
    setWPM(Math.max(wordsTyped, 0)); // Ensure WPM is not below 0

    const lastChar = value[value.length - 1];
    if (lastChar && para[value.length - 1] !== lastChar) {
      setErrors(errors + 1);
    }

    const newAccuracy = ((value.length - errors) / value.length) * 100;
    setAccuracy(Math.max(newAccuracy, 0)); // Ensure accuracy is not below 0
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
    setWord('');
    setPara(practiceparagraphs[Math.floor(Math.random() * practiceparagraphs.length)]);
    setChrIndex(0);
    setWPM(0);
    setAccuracy(100);
    setErrors(0);
  };

  useEffect(() => {
    if (errors >= 30) {
      setShowNotification(true);
    }
  }, [errors]);

  const callbackRef = useCallback((input) => {
    if (input) {
      input.focus();
    }
  }, []);

  return (
    <div className="practiceB-css bg-ctr">
      <div className="go-back">
        <Link to="/explore" style={{ color: "white" }}>
          <BsArrowLeft />
        </Link>
      </div>
      <p>Error limit set to 30 Characters</p>
      {showNotification && 
        <CenteredMessage 
          message="30 errors reached. GAME OVER!" 
          onClose={handleCloseNotification} 
        />
      }
      <div className="wpm-acc">
        <p>
          {Math.floor(WPM)}
          <small> WPM</small>
        </p>
        <p>
          {Math.floor(accuracy)}%
          <small> Accuracy</small>
        </p>
        <p>
          {Math.floor(errors)}
          <small> Errors</small>
        </p>
      </div>
      {!showNotification && (
        <input
          type='text'
          value={word}
          autoFocus
          onChange={handleWordType}
          ref={callbackRef}
          style={{ opacity: 0 }}
        />
      )}
      <Characters
        para={para}
        word={word}
        chrIndex={chrIndex}
      />
    </div>
  );
};

export default ErrorMode;
